import React from "react";

export const Team = () => {
  return (
    <div id="team" className="text-center bg-black text-white py-8">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto mb-8">
          <h2 className="text-6xl font-bold mb-4" style={{ fontSize: '4rem', marginTop: '-2rem' }}>Get your results!</h2>
          <p className="text-gray-300 text-2xl">
            Here are some examples of AI-generated cheat sheets created by our platform
          </p>
        </div>
        <div className="flex flex-col md:flex-row justify-center gap-8">
          <div className="w-full md:w-[1000px] h-auto md:h-[1500px]">
            <img 
              src="/images/hero2.png" 
              alt="Example cheat sheet 1" 
              className="w-full h-auto object-contain rounded-lg shadow-lg mx-auto" 
              style={{ maxWidth: '100%' }}
            />
          </div>
          <div className="w-full md:w-[1000px] h-auto md:h-[1500px]">
            <img 
              src="/images/hero3.png" 
              alt="Example cheat sheet 2" 
              className="w-full h-auto object-contain rounded-lg shadow-lg mx-auto"
              style={{ maxWidth: '100%' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
